<template>
  <div>
    <h2 class="font-medium text-xl mb-6">Facebook Integration</h2>
    <BaseFetchData :action="fetchData">
      <!-- props
        fetchData, status.loading, status.resolved, status.rejected, rejectReason
      -->
      <template #default="fetchDataProps">
        <div v-if="fetchDataProps.status.resolved">
          <ConnectFacebook
            v-if="!facebookIntegration"
            :account-id="accountId"
            @connected="handleFacebookConnected"
          />
          <FacebookServiceDetails
            v-else
            :access-token="facebookIntegration.access_token"
            :permissions="facebookIntegration.permissions?.data || []"
          />
        </div>
      </template>
    </BaseFetchData>
  </div>
</template>

<script>
import ConnectFacebook from './components/ConnectFacebook.vue';
import FacebookServiceDetails from './components/FacebookServiceDetails.vue';
import { accountFacebookIntegrationsClient } from '@/api/clients';

export default {
  components: {
    ConnectFacebook,
    FacebookServiceDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      facebookIntegration: null,
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await accountFacebookIntegrationsClient.read(this.accountId);

        this.facebookIntegration = response.data;
      } catch (error) {
        //
      }
    },
    handleFacebookConnected() {
      this.$router.replace({
        name: 'accounts.accountId.settings.integrations',
        params: this.$route.params,
      });
    },
  },
};
</script>
